<script>
// components
import SlideTypeListV2 from '@/components-v2/presentation-editor/new-slide/SlideTypeListV2.vue'
import EventBus from '@/eventBus'
import { mapState } from 'vuex'

export default {
  extends: SlideTypeListV2,
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      slides: (state) => state.presentation.slides,
    }),
  },
  methods: {
    async handleSelectSlideType({ item, property }) {
      if (item.isLegacy || item.disabled) {
        return
      }
      if (item.isSmokeTest) {
        this._handleSmokeTestSlideType(item)
        return
      }

      if (this.isForPairPlan(item)) {
        this.showSlideTypeTooltip = item.name
        return
      }
      this.loadingItem = item.type + item.slideType

      try {
        if (this.slides.length === 0) {
          EventBus.$emit('slide-search-popup:add-new-slide')
        }
        await this.selectSlideType({ item, property })
      } finally {
        this.loadingItem = null
      }

      if (this.wrapperId === 'slide-search-popup') {
        EventBus.$emit('slide-search-popup:close')
      }
      if (!this.slideActive.type) {
        this.$store.state.isOpenEditSlidePowerPoint = false
      }
    },
  },
}
</script>
